export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE = 1;
export const TABLE_PAGE_SIZE_VARIANTS = [5, 20, 50, 100];
